var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubstitutionOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96258 12.1707L12.1333 12.1707C12.612 12.1707 13 11.7637 13 11.2616C13 10.7595 12.612 10.3525 12.1333 10.3525L2.95539 10.3525L5.37949 7.80973C5.71795 7.45471 5.71795 6.8791 5.37949 6.52408C5.04104 6.16906 4.4923 6.16906 4.15384 6.52408L0.253842 10.615C0.0841579 10.793 -0.0004551 11.0264 2.50178e-06 11.2597L6.93525e-07 11.2616C6.5731e-07 11.5378 0.117397 11.7852 0.302697 11.9519L4.15384 15.9915C4.4923 16.3466 5.04104 16.3466 5.37949 15.9915C5.71795 15.6365 5.71795 15.0609 5.37949 14.7059L2.96258 12.1707Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1769 3.71009L8.53333 3.71009C8.23878 3.71009 8 3.9543 8 4.25555C8 4.55679 8.23878 4.801 8.53333 4.801L14.1813 4.801L12.6895 6.32666C12.4813 6.53968 12.4813 6.88504 12.6895 7.09805C12.8978 7.31107 13.2355 7.31107 13.4438 7.09805L15.8438 4.64351C15.9482 4.53671 16.0003 4.39665 16 4.25668L16 4.25555C16 4.08985 15.9278 3.94141 15.8137 3.84137L13.4438 1.41757C13.2355 1.20456 12.8978 1.20456 12.6895 1.41757C12.4813 1.63058 12.4813 1.97595 12.6895 2.18896L14.1769 3.71009Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstitutionOff);
export default __webpack_public_path__ + "static/media/substitution-off.d9fa8a154d8cae5ea3648690ec66725d.svg";
export { ForwardRef as ReactComponent };